<script>
import { mapGetters } from 'vuex';
import CompareListPlaceholder from './CompareListPlaceholder.vue';
import CompareListTable from './CompareListTable.vue';

export default {
  name: 'CompareList',
  components: { CompareListPlaceholder, CompareListTable },
  computed: {
    ...mapGetters({
      products: 'compare/products',
    }),
    isLoading() {
      return !this.products || this.products.length === 0;
    },
  },
};
</script>

<template>
  <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-0 lg:-mx-0">
    <div class="inline-block min-w-full py-2 align-middle">
      <div class="overflow-hidden shadow-sm ring-1 ring-black ring-opacity-5">
        <CompareListPlaceholder v-if="isLoading" />
        <CompareListTable v-else />
      </div>
    </div>
  </div>
</template>
